// Page entry. PRD 08 §1.2:
//   - METADATA:NO_PERMISSION → LNB hidden + entry blocked (rendered as the
//     NoPermissionGate below if a user navigates directly to /disease-code).
//   - READ / WRITE / Root → see the page; component-level write checks gate
//     the CRUD controls.

import { useTranslation } from 'react-i18next';

import { useRequirePermission } from '@/shared/hooks/useRequirePermission';
import { DiseaseCodeManagementView } from '@/features/disease-code/components/DiseaseCodeManagementView';

export function DiseaseCodeManagementPage() {
  const { t } = useTranslation('admin');
  const canRead = useRequirePermission('METADATA', 'READ');

  if (!canRead) return null;

  return (
    <>
      <div className="content__header">
        <div>
          <h1 className="content__title">{t('diseaseCodeManagement.title')}</h1>
        </div>
      </div>
      <div className="content__body">
        <DiseaseCodeManagementView />
      </div>
    </>
  );
}
